import { styled } from '@mui/material';

export default styled('pre')({
  margin: 0,
  fontFamily: 'Consolas, Menlo, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
});
